import { SbsPlayerGlobal } from '../../../../../common';

/**
 * 슬로우모션 버튼 구현
 */
customElements.define(
  'sbs-player-slowmotion-button',
  class extends HTMLElement {
    constructor() {
      super();
      this.button_id = `sbs-player-slowmotion-button-${SbsPlayerGlobal.id.uuid}`;
      this.isSlowMotion = false; // 슬로우모션 활성화 상태
    }

    connectedCallback() {
      try {
        this.render();
        this.listenSpeedChanges();
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        this.innerHTML = `<div class="controlSelect-slow">
                    <button id="${
                      this.button_id
                    }" type="button" class="btnText-slow ${
          this.isSlowMotion ? 'current' : ''
        }" aria-label="슬로우모션" aria-expanded="${
          this.isSlowMotion
        }"><span class="text-name">슬로우모션</span></button>
                </div>`;
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      const button = this.querySelector(`#${this.button_id}`);

      button.addEventListener('click', (event) => {
        event.preventDefault();

        // 토글 동작: 슬로우모션 ↔ 일반 속도
        if (this.isSlowMotion) {
          // 일반 속도로 복귀 (1.0x)
          this.isSlowMotion = false;
          SbsPlayerGlobal.events.emitEvent('select-change-speed', 1.0);
          console.log('슬로우모션 해제: 1.0 배속');
        } else {
          // 슬로우모션 활성화 (0.2x)
          this.isSlowMotion = true;
          SbsPlayerGlobal.events.emitEvent('select-change-speed', 0.2);
          console.log('슬로우모션 활성화: 0.2 배속');
        }

        // UI 업데이트
        this.updateButtonState();
      });

      button.addEventListener('keydown', (event) => {
        if (event.code === 'Space' || event.code === 'Enter') {
          button.click();
        }
      });
    }

    listenSpeedChanges() {
      // 배속 메뉴에서 속도가 변경되었을 때 슬로우모션 상태 업데이트
      SbsPlayerGlobal.events.addEventListener(
        'select-change-speed',
        (speed) => {
          // 다른 곳에서 속도가 변경된 경우
          if (speed !== undefined && speed !== null) {
            // 0.2 배속이면 슬로우모션 활성화, 아니면 비활성화
            const wasSlowMotion = this.isSlowMotion;
            this.isSlowMotion = Math.abs(speed - 0.2) < 0.01;

            // 상태가 변경되었으면 UI 업데이트
            if (wasSlowMotion !== this.isSlowMotion) {
              this.updateButtonState();
            }
          }
        }
      );
    }

    updateButtonState() {
      const button = this.querySelector(`#${this.button_id}`);

      if (button) {
        button.setAttribute('aria-expanded', this.isSlowMotion);
        if (this.isSlowMotion) {
          button.classList.add('current');
        } else {
          button.classList.remove('current');
        }
      }
    }
  }
);
